import { fetchInvestor } from 'actions/investors';
import asyncDispatcher from 'utils/asyncDispatcher';

export const createInvestment = (attrs) => (dispatch, getState) => {
  const { api } = getState().app;

  return api.createInvestment(attrs)
    .then(resp => {
      dispatch(fetchInvestor(attrs.investorId));
    });
};

export const updateInvestment = (attrs) => (dispatch, getState) => {
  const { api } = getState().app;

  return api.updateInvestment(attrs)
    .then(resp => {
      dispatch(fetchInvestor(attrs.investorId));
    });
};



// WEBPACK FOOTER //
// ./src/actions/investments.js